module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsSAAALEgHS3X78AAAAVUlEQVQYlWNABv/zbBwYcAAmmDBU0f7/eTYJ2JTCFTJOOnKAgYEhkYGBYT4uxejWJ/zPs/lPtmK41SQDoqzGp4gRSRE4eEA+Z5x0ZAEhT2APcAYGBgBrWC2TccwKAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_breadcrumbs_arrow.png
// module id = 884
// module chunks = 0